export default __webpack_public_path__ + "static/media/vector_soon_1.77c3c579.png";